<template>
    <List
        @update="$emit('update')"
        funcionalidade="livro-talidomida"
    />
</template>

<script>
import List from '@/components/farmacia/livro/List'

export default {
    components: { List },
}
</script>